module.exports = __webpack_public_path__ + "static/pm-55b6e2e59f31b773f3ddfa1913824ec3.png";